export enum DataPointOccurrence {
  Last_Recorded = 'Last_Recorded',
  Today = 'Today',
  Yesterday = 'Yesterday',
  Intended_Start_Date = 'Intended_Start_Date',
  Last_Thirty_Days = 'Last_Thirty_Days'
}
